import { useLayoutStore } from '@Models/useLayoutModel';
import { Flex, TonicProps } from '@tonic-one/react';
import { ReactNode } from 'react';

const Shell = (props: { children?: ReactNode } & TonicProps) => {
  const { children, ...tonicProps } = props;
  const { layoutHeight } = useLayoutStore();
  return (
    <Flex flexDirection="column" height={layoutHeight} {...tonicProps}>
      {children}
    </Flex>
  );
};

const ShellHeader = (props: { children?: ReactNode } & TonicProps) => {
  const { children, ...tonicProps } = props;
  return (
    <Flex flexDirection="column" flexShrink={0} {...tonicProps}>
      {children}
    </Flex>
  );
};

const ShellFooter = (props: { children?: ReactNode } & TonicProps) => {
  const { children, ...tonicProps } = props;
  return (
    <Flex flexDirection="column" flexShrink={0} {...tonicProps}>
      {children}
    </Flex>
  );
};

const ShellContent = (props: { children?: ReactNode } & TonicProps) => {
  const { children, ...tonicProps } = props;
  return (
    <Flex flexDirection="column" flex={1} overflow="auto" {...tonicProps}>
      {children}
    </Flex>
  );
};

export { Shell, ShellHeader, ShellFooter, ShellContent };
